module.exports = __webpack_public_path__ + "img/76800.8220f732.jpg";